import { Box } from "@mui/material";
import { Fragment, useEffect } from "react";
import { Outlet } from "react-router-dom";
import { GlobalBackdrop, useReduxThunkCache, WithChildren } from "@duosoftbg/nacid-components";
import Header from "../components/common/layout/Header";
import AdminConsoleSidebar from "../components/common/sidebar/AdminConsoleSidebar";
import SidebarButton from "../components/common/sidebar/common/SidebarButton";
import useMediaQuery from "@mui/material/useMediaQuery";
import { Breakpoint } from "@mui/system/createTheme/createBreakpoints";
import { useTheme } from "@mui/material/styles";
import useAppDispatch from "../../hooks/redux/base/useAppDispatch";
import { hide, show } from "../../store/redux/slice/Sidebars/adminConsoleSidebar";
import useAppSelector from "../../hooks/redux/base/useAppSelector";
import { aConsoleDataThunk } from "../../store/redux/slice/AppData/aConsoleData";
import Footer from "../components/common/layout/Footer";
import { AppModulesPageBlockerDialog } from "@duosoftbg/nacid-frontoffice-components";

const AdminConsoleLayout = (props: WithChildren) => {
  const { children } = props;
  const { thunkEffect } = useReduxThunkCache();
  const theme = useTheme();
  const dispatch = useAppDispatch();
  const matchesXl = useMediaQuery(theme.breakpoints.down("xxl" as Breakpoint));
  const thunkState = useAppSelector((state) => {
    return state.AppData.aConsoleData;
  });

  useEffect(() => {
    if (matchesXl) {
      dispatch(hide());
    } else {
      dispatch(show());
    }
  }, [dispatch, matchesXl]);

  useEffect(() => {
    thunkEffect({
      thunkFn: aConsoleDataThunk,
      thunkState: thunkState,
    });
    // eslint-disable-next-line
  }, []);

  return (
    <Fragment>
      <Header />
      <SidebarButton />
      <AdminConsoleSidebar />
      <Box>
        {children}
        <Outlet />
      </Box>
      <Footer />
      <GlobalBackdrop />
      <AppModulesPageBlockerDialog />
    </Fragment>
  );
};

export default AdminConsoleLayout;
